export default __webpack_public_path__ + "static/media/SEC2030.34I-42171_-25370_0.6822dd3f.jpg";